<template>
  <div
    class="evento-card"
    :class="{
      'evento-finalizado': estadoCurso === 'finalizado',
      'evento-confirmado': estadoCurso === 'confirmado',
    }"
    @click="$emit('detalle')"
  >
    <div class="badge-top">
      <div class="icons-col">
        <i class="fas fa-graduation-cap"></i>
      </div>
      <h6 class="title mb-0 text-left">{{ norma }}</h6>
    </div>

    <hr class="sep" />

    <!-- CONTENIDO -->
    <div class="inner">
      <div class="d-flex align-items-center">
        <i class="far fa-building mr-2"></i>
        <span class="title mb-0 text-left">{{ nombre }}</span>
      </div>

      <div class="d-flex align-items-center">
        <i class="far fa-clock mr-2"></i>
        <span class="text-req">{{
          formatearRangoHoras(horaInicio, horaFin)
        }}</span>
      </div>
      <div class="text-right">
        <span class="badge" :class="estadoBadgeClase">{{
          estadoBadgeTexto
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EventoCard",
  props: {
    norma: { type: String, default: "" },
    horaInicio: { type: String, required: true },
    horaFin: { type: String, required: true },
    nombre: { type: String, required: true },
    edo: { type: Number, requered: false },
    estadoCapacitador: { type: String, default: "" },
  },
  data() {
    return {
      nombrecot: this.nombre ? this.combre : "SIN DATO",
    };
  },
  computed: {
    estadoCurso() {
      if (this.edo === 1) return "finalizado";
      return this.estadoCapacitador || "por_confirmar";
    },
    estadoBadgeTexto() {
      return {
        por_confirmar: "Por confirmar",
        confirmado: "Confirmado",
        finalizado: "Finalizado",
        historico: "Histórico",
      }[this.estadoCurso] || "Por confirmar";
    },
    estadoBadgeClase() {
      return {
        por_confirmar: "badge-warning",
        confirmado: "badge-primary",
        finalizado: "badge-success",
        historico: "badge-secondary",
      }[this.estadoCurso] || "badge-warning";
    },
  },
  methods: {
    formatearRangoHoras(inicio, fin) {
      const formatoHora = (fecha) => {
        const hora = new Date(fecha).getUTCHours().toString().padStart(2, "0");
        const minuto = new Date(fecha)
          .getUTCMinutes()
          .toString()
          .padStart(2, "0");
        return `${hora}:${minuto}`;
      };

      return `${formatoHora(inicio)} a ${formatoHora(fin)} hrs.`;
    },
  },
};
</script>

<style>
.evento-card {
  cursor: pointer;
  border-left: 6px solid #0a3c71;
  border-radius: 7px;
  background-color: #ffffff;
  position: relative;
  box-shadow: 0 2px 10px rgba(17, 38, 146, 0.08);
  overflow: hidden;
  padding-left: 5px;
  margin-bottom: 1rem;
  transition: all 0.3s ease-in-out;
}

.evento-card:hover {
  transform: scale(1.02);
}

.evento-confirmado {
  border-left-color: #2563eb;
}

/* Cinta superior */
.badge-top {
  color: #6c757d;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 10px 16px;
  display: flex;
  align-items: center;
}

/* Separador */
.sep {
  border: 0;
  border-top: 1px solid #e9edf5;
  margin: 8px 0 10px;
}

/* Interior */
.inner {
  padding: 14px 16px 16px 16px;
}
.icons-col {
  color: #0f3e82;
  margin-right: 8px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
}

.btn-detalle {
  display: block;
  width: 100%;
  background-color: #0a3c71;
  color: #fff;
  box-shadow: none;
  border: none;
  border-radius: 5px;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
}
</style>
